import React, { Component } from "react"
import { Waypoint } from "react-waypoint"
import { throttle } from "throttle-debounce"
import { Document, Page, pdfjs } from "react-pdf"

import "./pdfView.scss"
import "react-pdf/dist/Page/AnnotationLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

class PDFView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pagesLoaded: 0,
      loading: false,
      width: null,
    }

    this.file = {
      url: this.props.url,
      withCredentials: this.props.withCredentials || false,
    }

    this.throttledResize = throttle(500, this.resizeWindow)
  }

  componentDidMount = () => {
    this.resizeWindow()
  }

  resizeWindow = () => {
    let { width } = this.pdf.getBoundingClientRect()
    this.setState({
      width: width * 0.9,
    })
  }

  zoomIn = () => {
    this.setState(({ width }) => ({
      width: width + 100,
    }))
  }

  zoomOut = () => {
    this.setState(({ width }) => ({
      width: width - 100,
    }))
  }

  onDocumentLoad = (info) => {
    this.setState({
      pagesLoaded: Math.min(info.numPages, 3),
      numPages: info.numPages,
    })
  }

  loadMorePages = () => {
    this.setState((state) => ({
      pagesLoaded: Math.min(state.numPages, state.pagesLoaded + 4),
    }))
  }

  _renderPage = (i) => {
    return (
      <div key={i} className="pdf-page-container">
        <Page
          pageIndex={i}
          className="pdf-page"
          renderInteractiveForms={true}
          width={this.state.width - 40}
        />
      </div>
    )
  }

  _renderMessage = (message) => <div className="pdf-message">{message}</div>

  _renderDocument = () => {
    if (!this.state.width) {
      return this._renderMessage("Loading...")
    }

    let pages = []
    for (let i = 0; i < this.state.pagesLoaded; i++) {
      pages.push(
        <div key={i} className="pdf-page-container">
          <Page
            pageIndex={i}
            className="pdf-page"
            renderInteractiveForms={true}
            width={this.state.width - 40}
          />
        </div>
      )
    }

    return (
      <React.Fragment>
        <Document
          className="pdf-document"
          file={this.file}
          error={this._renderMessage("Failed to load PDF")}
          loading={this._renderMessage("Loading...")}
          onLoadSuccess={this.onDocumentLoad}
        >
          {pages}
          {this.state.pagesLoaded < this.state.numPages && (
            <div id="loading-more-pages">
              <Waypoint
                onEnter={this.loadMorePages}
                fireOnRapidScroll={true}
                bottomOffset="-700px"
              />
              Loading more pages...
            </div>
          )}
        </Document>
        <div id="pdf-resize-buttons">
          <div
            className="resize-button fit-to-width"
            onClick={this.resizeWindow}
          >
            <div>
              <span />
            </div>
          </div>
          <div className="resize-button" onClick={this.zoomIn}>
            <span className="glyphicon glyphicon-zoom-in" />
          </div>
          <div className="resize-button" onClick={this.zoomOut}>
            <span className="glyphicon glyphicon-zoom-out" />
          </div>
        </div>
      </React.Fragment>
    )
  }

  render = () => {
    return (
      <div className="pdf-view-container" ref={(ref) => (this.pdf = ref)}>
        {this._renderDocument()}
      </div>
    )
  }
}

export default PDFView
